const en = {
  header: {
    navigation: {
      home: 'Home',
      learning: 'Learning',
      pricing: 'Pricing',
      aboutUs: 'About us',
    },
    actions: {
      login: 'Log in',
      bookCall: 'Book a call',
    },
    aria: {
      menu: 'menu',
    },
  },
  cta: {
    title: {
      line1: "Let's Build a Smarter",
      line2: 'Company Together',
    },
    subtitle: {
      line1: 'Ready to leave chaos',
      line2: 'behind and confidently',
      line3: 'scale your business?',
    },
    button: 'Start your journey with Mr. Wolf today',
  },
  auth: {
    signInError: 'Sign-in Error',
    signInErrorDescription: 'There was an error signing in. Are you sure you already have an account?',
    login: 'Go to Login and Try Again',
    createAccount: 'Create my Account Now',
  },
  login: {
    aiAssistedMessage: 'AI-assisted process documentation',
    welcomeBack: 'Welcome back!',
    signInGoogle: 'Sign In with Google',
    or: 'or',
    email: 'Email',
    enterEmail: 'Enter your email',
    password: 'Password',
    rememberMe: 'Remember me',
    rememberMeMessage: 'Check this box to stay logged in this device.',
    forgotPassword: 'Forgot password?',
    sendResetCode: 'Send reset code',
    forgotPasswordMessage: 'Enter your email to receive a reset code',
    signIn: 'Sign In',
    resetPassword: 'Reset Password',
    resetPasswordMessage: 'Enter the reset code you received and your new password',
    passwordResetCode: 'Password reset code',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    enterPasswordResetCode: 'Enter the password reset code you received',
    writeNewPassword: 'Write a new password',
    confirmNewPassword: 'Confirm the new password',
    passwordsDoNotMatch: 'Passwords do not match',
    allFieldsRequired: 'All fields are required',
    enterTempPassword: 'Enter the temporary password you received',
    tempPassword: 'Temporary password',
    confirmUserMessage: 'Looks like you are doing the initial login, please enter a new password below.',
    confirmUserMessagePasswordRequirements:
      'Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.',
    initialLoginMessage: 'You should have received the welcome message, please enter the password below',
    signUp: 'Sign Up',
    createYourOrganization: 'Create your organization',
    signupDescription: 'Start your journey with Mr. Wolf by creating your organization account',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    writePassword: 'Write your password',
    emailVerificationSent: 'Verification email sent!',
    checkYourEmail: 'Please check your email to verify your account and complete the registration process.',
    backToLogin: 'Back to Login',
    serviceStatus: 'Service Status',
    accountOwnerInformation: 'Account Owner Information',
    agreeToTerms: 'I agree to the',
    termsAndConditions: 'Terms and Conditions',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    mustAcceptTerms: 'You must agree to the Terms and Conditions and Privacy Policy to create an account',
    emailTooltip:
      'You will receive a temporary password here. If it is a Google account, you can also use Google SSO to login.',
  },
  logout: {
    singleWindowPolicy: 'Single Window Policy',
    noSessionDetected: 'No Session Detected',
    noSeatTitle: 'No Active Seat Assigned',
    singleWindowMessage:
      'You have been logged out because you signed in from another browser window or tab. Only one active session is allowed at a time for security.',
    noSessionMessage: 'You have been logged out because your session is corrupt or expired.',
    noSeatMessage: 'Access denied: No active seat assigned. Please contact your organization administrator.',
    securityNote: 'For your security, Mr. Wolf enforces a single-window session policy:',
    policyPoints: {
      oneWindow: 'Only one browser window/tab can be logged in at a time',
      invalidation: 'Previous sessions are automatically invalidated',
      unauthorized: 'This prevents unauthorized access to your account',
    },
    redirectingIn: 'Redirecting to login in',
    seconds: 'seconds...',
    loginNow: 'Login Now',
    loggingOut: 'Logging out...',
  },
  //TODO: I would refactor these using element + action to avoid so much repetition
  actionMessages: {
    areasReorderedSuccessfully: 'Areas reordered successfully',
    areaDeletedSuccessfully: 'Area deleted successfully',
    areaCreatedSuccessfully: 'Area created successfully',
    areaUpdatedSuccessfully: 'Area updated successfully',
    integrationDeletedSuccessfully: 'Integration deleted successfully',
    discrepancyUpdatedSuccessfully: 'Discrepancy updated successfully',
    policyCreatedSuccessfully: 'Policy created successfully',
    policyUpdatedSuccessfully: 'Policy updated successfully',
    policyDeletedSuccessfully: 'Policy deleted successfully',
    processesReorderedSuccessfully: 'Processes reordered successfully',
    stepCreatedSuccessfully: 'Step created successfully',
    noStepsToExecute: 'No steps to execute',
    stepDeletedSuccessfully: 'Step deleted successfully',
    stepUpdatedSuccessfully: 'Step updated successfully',
    triggerCreatedSuccessfully: 'Trigger created successfully',
    triggerUpdatedSuccessfully: 'Trigger updated successfully',
    processCreatedSuccessfully: 'Process created successfully',
    processUpdatedSuccessfully: 'Process updated successfully',
    stepsReorderedSuccessfully: 'Steps reordered successfully',
    linkSuccessfullyUpdated: 'Link successfully updated',
    deleteSuccessful: 'Delete successful',
    serviceCreatedSuccessfully: 'Service created successfully',
    servicesReorderedSuccessfully: 'Services reordered successfully',
    updateSuccessful: 'Update successful',
    avatarUpdatedSuccessfully: 'Avatar updated successfully',
    languageUpdatedSuccessfully: 'Language updated successfully',
    profileUpdatedSuccessfully: 'Profile updated successfully',
    documentUpdatedSuccessfully: 'Document updated successfully',
    organizationCreatedSuccessfully: 'Organization created successfully',
    organizationEditedSuccessfully: 'Organization edited successfully',
    organizationEnabledSuccessfully: 'Organization enabled successfully',
    organizationDisabledSuccessfully: 'Organization deleted successfully',
    userCreatedSuccessfully: 'User created successfully',
    userEditedSuccessfully: 'User edited successfully',
    userDisabledSuccessfully: 'User deleted successfully',
    userEnabledSuccessfully: 'User enabled successfully',
    loginNoEmail: 'No email, enter your email and click "Forgot password" again',
    fillPolicyFields: 'Please fill the policy name and specify at least some content',
    fillAreaFields: 'Please fill the area name, description and color',
    fillServiceFields: 'Please pick an area, fill the service name, description and color',
    requestError: 'Request error, please try again',
    whileImpersonatingError: 'Action not allowed while impersonating',
    linkCopied: 'Link copied to clipboard',
    impersonateFailed: 'Impersonation failed',
    impersonateCleared: 'Stopped impersonating',
    impersonateClearFailed: 'Impersonation clear failed, logging out...',
    staleImpersonationCleared: 'Impersonation was cleared due to page reload',
    youMustFirstSaveTheStep: 'Unable to delete yet. You must first save the step',
    cannotDeleteOnlyStep: 'Cannot delete the only step in a process',
    generatedFromClearSuccess: 'Generated from document cleared successfully',
    stepNameRequired: '"What happens here" is required',
    nameDescriptionColorRequired: 'Name, description and color are required',
    processNameGoalServiceRequired: 'Process name, goal and service are required',
    triggerNameRequired: 'Trigger name is required',
    triggerNameExists: 'A trigger with this name already exists. Please choose a different name.',
    invalidOrganizationData: 'Error.Make sure you have a name, email, first and last name and the email is valid.',
    invalidEmail: 'Please enter a valid email address',
    accountCreatedSuccessfully: 'Account created successfully! Check your email for login instructions.',
    userAlreadyExists: 'This email is not available. If you are already registered, please sign in.',
    changesSavedSuccessfully: 'Changes saved successfully',
    failedLoginAttemptsReset: 'Failed login attempts reset successfully',
    passwordUpdatedSuccessfully: 'Password updated successfully',
    processStatusUpdated: 'Process status updated successfully',
    processStatusUpdateError: 'Error updating process status',
    processClonedSuccessfully: 'Process cloned successfully',
    processStatusUpdateSuccess: 'Process status updated successfully',
    feedbackSubmittedSuccessfully: 'Feedback submitted successfully',
    feedbackMinimalLength: 'The feedback needs to be at least 5 characters long',
    userRoleUpdatedSuccessfully: 'User role updated successfully',
    userRemovedFromOrganizationSuccessfully: 'User removed from organization successfully',
    userAddedToOrganizationSuccessfully: 'User added to organization successfully',
    userRestoredToOrganizationSuccessfully: 'User restored to organization successfully',
    switchedToOrganization: 'Switched to organization',
    failedToSwitchOrganization: 'Failed to switch organization. Please try again.',
    fileTooLarge: 'The file is too large. Please select a smaller file.',
  },
  areas: {
    title: 'Areas',
    addNew: 'Add New Area',
    edit: 'Edit Area',
    activity: 'Activity',
    noActivity: 'No activity yet. Here you will see the latest updates & changes.',
    createArea: 'Create Area',
    editArea: 'Edit Area',
    servicesInside: 'Services within this Area',
    emptyAreaMessage: 'This organization contains no areas yet, create one to get started.',
    name: 'What is this area called?',
    description: 'Describe what this area does',
    color: 'What color should represent this area?',
  },
  integrations: {
    title: 'Integrations',
    type: 'Type',
    provider: 'Provider',
    status: 'Status',
    structure: 'Structure',
    clickToEnable: 'Enable',
    refreshAfterOAuthMessage: 'After completing the integration flow, if you do not see it connected here, please refresh the page.',
    clickToGenerateStructure: 'Generate structure',
    generatingInProgress: 'Generating structure...',
    generatingInProgressTooltip: 'Structure generation is in progress. This may take a few minutes. Please wait before taking any other action.',
    generationFailed: 'Generation failed. Please delete and try again.',
    enabledGenerated: 'Enabled and Structure Generated',
    integrationDone: 'Integration done',
    success: 'Integration successfully activated, you can now close this tab',
    enablingIntegration: 'Hold on, enabling the integration',
    error: 'Integration error, please retry later',
    checksTitle: 'Integration checks',
    confirmDelete: 'Are you sure you want to delete this integration?',
    confirmDeleteMessage: 'This will remove the existing integration of type {type} with {provider}.',
    confirmDeleteMessageCalendar:
      "The application will stop linking to your calendar account setup, however your calendars will not be deleted. If you want to remove each service's calendar, you need to do it manually",
    confirmDeleteMessageStorage:
      'The application will stop updating to your storage, however your folders will not be deleted. Folders for each area (with subfolders for services) as well as your global policy and templates folder will remain. If you wish to do so, you can remove them manually.',
    confirmGenerate: 'Set up integration?',
    confirmGenerateMessage:
      'We will create and configure the {type} integration with {provider}.\nYour existing data will remain unchanged.\n\n',
    confirmGenerateMessageCalendar:
      'We will create:\n• A calendar for each service in your organization\n• Calendar events for all calendar-triggered processes\n\nYour existing calendars will not be affected.',
    confirmGenerateMessageStorage:
      'We will create the following folder structure:\n• One folder for each area (with service subfolders)\n• A global policies folder\n• A templates folder\n• Documents for all policies and processes',
    confirmGenerateBackgroundNote:
      'This process will continue in the background. Please allow a few minutes for it to complete. You can safely close this dialog and continue working.',
    generateTooltip: 'Will create a structure for the integration, click to see details',
    connectedAccount: 'Connected Account',
    connectedAs: 'Connected as {email}',
    connectedOn: 'Connected on {date}',
    connectedBy: 'by {name}',
    recheckDiscrepancies: 'Manually recheck discrepancies',
    recheckSuccess: 'Discrepancies recheck completed successfully',
    recheckDisabledMessage: 'You recently manually updated. You will be able to do it again in a few minutes.',
    filterDocument: 'Filter by Document Name',
    showInactive: 'Show Inactive',
    ignore: 'Postpone',
    discrepancyParentType: 'Discrepancy Type',
    integrationType: 'Integration Type',
    createdAt: 'Created At',
    involvedDocument: 'Involved Document',
    foundDiscrepancy: 'Found Discrepancy',
    solution: 'Solution',
    ignorePermanently: 'Postpone Permanently',
    ignoreMonth: 'Postpone for 1 Month',
    ignoreDay: 'Postpone for 1 Day',
    ignoreCustom: 'Postpone for Custom Period',
    trustIntegration: 'Discard suggestions',
    goToProcess: 'Go to Process',
    generatingStorageStructure: 'Generating storage structure...',
    generatingStorageMessage1: 'Creating area folders...',
    generatingStorageMessage2: 'Setting up service subfolders...',
    generatingStorageMessage3: 'Creating policy documents...',
    generatingStorageMessage4: 'Generating process documents...',
    generatingStorageMessage5: 'Finalizing structure...',
    generatingCalendarStructure: 'Generating calendar structure...',
    generatingCalendarMessage1: 'Looking for existing calendars...',
    generatingCalendarMessage2: 'Creating service calendars...',
    generatingCalendarMessage3: 'Setting up calendar permissions...',
    generatingCalendarMessage4: 'Creating calendar events...',
    generatingCalendarMessage5: 'Linking triggers to events...',
    generatingCalendarMessage6: 'Finalizing structure...',
    // Health status
    healthStatus: 'Health',
    healthHealthy: 'Healthy',
    healthUnhealthy: 'Unhealthy',
    healthUnknown: 'Unknown',
    healthHealthyDescription: 'Integration is working normally. Recent operations completed successfully.',
    healthUnhealthyDescription: 'Integration has failed 5 or more times in a row. Check your connection or re-authenticate.',
    healthUnknownDescription: 'No recent activity. Health will update after the next operation.',
    failedAttempts: '{count} failed attempts',
    lastChecked: 'Last checked: {time}',
    justNow: 'just now',
    minutesAgo: '{count}m ago',
    hoursAgo: '{count}h ago',
    daysAgo: '{count}d ago',
    slackDescription: 'Send notifications to users via Slack DM',
    slackInternalOnlyTooltip: 'The Slack integration may not be available to you. If that is the case, support for enabling it in your organization is coming soon.',
    confirmDeleteMessageSlack:
      'Slack notifications will be disabled for all users in this organization. Users will no longer receive Slack DMs for process assignments and reminders.',
    slackConnectedSuccess: 'Slack connected successfully!',
    slackConnectionFailed: 'Slack connection failed: {error}',
  },
  discrepancies: {
    title: 'Discrepancies & Pending Actions',
    type: 'Type',
    provider: 'Provider',
    status: 'Status',
    structure: 'Structure',
    types: {
      PROCESS_IMPROVEMENT: {
        label: 'Process Improvement',
        message: 'Suggested improvements for this process',
        optionWolf: {
          label: 'Improve with suggestions',
          message: 'Edit the process to apply these improvements',
        },
        optionWolfProcessPage: {
          label: "I've already adjusted it",
          message: 'Mark these improvements as applied',
        },
        optionIgnore: {
          label: 'Discard suggestions',
          message: 'These improvements are not relevant now',
        },
      },
      POLICY_NOT_FOUND: {
        label: 'Policy Not Found',
        message: 'Referenced policy could not be found',
        optionWolf: {
          label: 'Create policy',
          message: 'Create the missing policy document',
        },
        optionIgnore: {
          label: 'Postpone',
          message: 'Postpone policy creation for later',
        },
      },
      POLICY_NOT_CREATED: {
        label: 'Policy Not Created',
        message: 'Policy has not been created yet',
        optionWolf: {
          label: 'Create policy now',
          message: 'Generate the policy document',
        },
        optionIgnore: {
          label: 'Postpone',
          message: 'Postpone policy creation for later',
        },
      },
      PROCESS_NOT_UPDATED: {
        label: 'Process Not Updated',
        message: 'Process needs to be updated',
        optionWolf: {
          label: 'Update process',
          message: 'Apply the suggested updates to this process',
        },
        optionIgnore: {
          label: 'Keep current version',
          message: 'Keep the process as is for now',
        },
      },
      TRIGGER_CALENDAR_NOT_FOUND: {
        label: 'Calendar Event Not Found',
        message: 'Trigger references a calendar and event that no longer exists',
        optionWolf: {
          label: 'Regenerate calendar event',
          message: 'Create a new calendar and event for this trigger',
        },
        optionIgnore: {
          label: 'Clear event reference',
          message: 'Remove the calendar reference from this trigger',
        },
      },
    },
    clickToEnable: 'Enable',
    clickToGenerateStructure: 'Generate structure',
    enabledGenerated: 'Enabled and Structure Generated',
    integrationDone: 'Integration done',
    success: 'Integration successfully activated, you can now close this tab',
    checksTitle: 'Discrepancy Checks',
    pendingsTitle: 'Pendings',
    solveDiscrepancy: 'Solve Discrepancy',
    pendingsTooltip: 'Items that were left to be done when interacting with Mr. Wolf',
    checksTooltip: 'Automated checks that identify inconsistencies between Mr. Wolf and your integrations or other possible improvements',
    confirmDelete: 'Are you sure you want to delete this discrepancy?',
    confirmDeleteMessage: 'This will remove the existing discrepancy of type {type} with {provider}.',
    confirmGenerate: 'Fix integration setup?',
    confirmGenerateMessage:
      'We will create and configure the {type} integration with {provider}.\nYour existing data will remain unchanged.\n\n',
    confirmGenerateMessageCalendar:
      'We will create:\n• A calendar for each service in your organization\n• Calendar events for all calendar-triggered processes\n\nYour existing calendars will not be affected.\n\nIf you already had calendars setup for your services, we will try to use them instead of creating new ones.',
    confirmGenerateMessageStorage:
      'We will create the following folder structure:\n• One folder for each area (with service subfolders)\n• A global policies folder\n• A templates folder\n• Documents for all policies and processes',
    confirmGenerateBackgroundNote:
      'This process will continue in the background. Please allow a few minutes for it to complete. You can safely close this dialog and continue working.',
    generateTooltip: 'Will create a structure for the integration, click to see details',
    recheckDiscrepancies: 'Manually recheck discrepancies',
    recheckSuccess: 'Discrepancies recheck completed successfully',
    recheckDisabledMessage: 'You recently manually updated. You will be able to do it again in a few minutes.',
    filterDocument: 'Filter by Discrepancy Name',
    showInactive: 'Show Inactive',
    ignore: 'Postpone',
    discrepancyParentType: 'Discrepancy Type',
    integrationType: 'Integration Type',
    integrationTypes: {
      CALENDAR: 'Calendar',
      STORAGE: 'Storage',
      NOTES: 'Notes',
      ISSUE_TRACKER: 'Issue Tracker',
      OTHER: 'Other',
    },
    entities: {
      Trigger: 'Trigger',
      Process: 'Process',
      Policy: 'Policy',
      Service: 'Service',
      Area: 'Area',
    },
    createdAt: 'Created At',
    involvedDocument: 'Entity Involved',
    foundDiscrepancy: 'Found Discrepancy',
    solution: 'Solution',
    optionInteg: 'Fix by User Action',
    pendingType: 'Type',
    pendingName: 'Name',
    pendingStatus: 'Status',
    pendingDate: 'Date',
    pendingActions: 'Actions',
    completePending: 'Complete',
    continuePending: 'Continue',
    completePendingTooltip: 'Mark as complete and remove from pending list',
    continuePendingTooltip: 'Will interrupt the current conversation with Mr. Wolf and continue with this pending action',
    continuingPending: 'Continuing pending action...',
    ignorePermanently: 'Postpone Permanently',
    ignoreMonth: 'Postpone for 1 Month',
    ignoreDay: 'Postpone for 1 Day',
    ignoreCustom: 'Postpone for Custom Period',
    trustIntegration: 'Discard suggestions',
    okDoneIt: 'Ok I\'ve done it',
    remindInDay: 'Remind me in a day',
    remindInMonth: 'Remind me in a month',
    discardPermanently: 'Discard permanently',
    discrepancies: 'Discrepancies',
    possibleImprovements: 'Possible improvements',
  },
  policies: {
    addPolicy: 'Add Policy',
    category: 'Category',
    confirmDeleteTitle: 'Confirm Deletion',
    confirmDeleteMessage:
      'Are you sure you want to delete this policy? Please note that it is referenced in {count} processes.',
    content: 'Content',
    description: 'Policies are a set of rules that define the behavior of your processes.',
    policyContent: 'Policy Content',
    usedIn: 'This policy is used in the following processes:',
    view: 'View',
    contentTooltip: 'The content of the policy, all the rules that are defined by the policy',
    descriptionTooltip: 'The description of the policy, a brief explanation of what it covers',
    categoryTooltip:
      'The category of the policy, so that it can be grouped with others that cover the same issues (e.g. "Compliance", "Risk Management", "IT Security", etc.)',
    name: 'What is this policy called?',
    policyDescription: 'Describe what this policy covers',
    policyCategory: 'How should this policy be categorized?',
    policyContentLabel: 'What are the rules defined by this policy?',
    emptyPolicyMessage: 'This organization has no policies yet, create one to get started.',
  },
  processes: {
    title: 'Processes',
    addNew: 'Add New Process',
    edit: 'Edit Process',
    editTriggers: 'Edit Triggers',
    addStep: 'Add Step',
    allServices: 'All services',
    searchPlaceholder: 'Search by name or goal',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    normalStep: 'Normal Step',
    caseStep: 'Switch Step',
    loopStep: 'Repeat Step',
    condition: 'Condition',
    noCondition: 'No condition set for this step.',
    notes: 'Notes',
    noNotes: 'No notes set for this step.',
    policiesLinked: 'Policies linked',
    linkedProcess: 'Linked Process',
    linkedToProcess: 'Linked to Process',
    noLinked: 'No linked process for this step.',
    noTriggersYet: 'No triggers defined yet.',
    generatedFrom: 'Process generated from document',
    aNewStep: 'A new step',
    aNewRepeatStep: 'A new loop',
    aNewSwitchStep: 'New case',
    aNewCondition: 'New condition',
    conditionPrefix: 'Condition',
    generatedFromClear: 'Process generated from document, click here to clear this reference if no longer relevant',
    noPoliciesYet: 'No policies linked yet.',
    policiesClear: 'Click to unlink this policy from this process',
    selectPolicy: 'Select Policy',
    noRecurrence: 'No recurrence defined',
    saveStepBeforeMoving: 'You must save the step before trying to move it',
    markAsApproved: 'Mark as Approved',
    markAsDraft: 'Mark as Draft',
    markAsLocked: 'Mark as Locked',
    markProcessAsApproved: 'Mark Process as Approved',
    markProcessAsApprovedConfirmation: 'Would you like to mark this process as Approved?',
    markProcessAsDone: 'Mark Process as Approved',
    markProcessAsDoneConfirmation: 'Would you like to mark this process as Approved?',
    markProcessAsDoneCancel: 'No, leave as draft',
    markProcessAsDoneConfirm: 'Yes, mark as Approved',
    emptyProcessMessage: 'There are no processes to show yet.',
    createServicesFirst: 'You need to create services first',
    dropPlaceAtStart: 'Drop here to place at start',
    dropPlaceAtEnd: 'Drop here to place at end',
    dropInsideStep: 'Drop inside {stepName}',
    dropBelowStep: 'Add below {stepName}',
    cannotMoveContainerInside: 'Cannot move container steps inside other steps',
    markExecution: 'Execute',
    processFoundInOtherOrg: 'Process found in {organizationName}',
    switchToOrganization: 'Switch to that organization',
    processNotFound: 'Process Not Found',
    processNotFoundInAnyOrg: 'Process not found in any of your organizations',
    processNotFoundMessage: 'The process you are looking for does not exist or you do not have access to it.',
    executionTracking: 'Execution Tracking',
    startExecution: 'Start Execution',
    startingExecution: 'Starting execution...',
    executeProcess: 'Execute Process',
    stepExecution: 'Your notes about this execution',
    markStepDone: 'Completed',
    markStepNotDone: 'Skipped',
    markStepWithError: 'Completed with issues',
    stepDone: 'Done',
    stepNotDone: 'Not Done',
    stepWithError: 'Error',
    stepPending: 'Pending',
    stepInProgress: 'In Progress',
    stepSkipped: 'Skipped',
    currentStep: 'Current Step',
    executionNote: 'Execution Note',
    backToPreviousStep: 'Back to previous step',
    goBackStepSuccess: 'Went back to previous step',
    goBackStepNoPrevious: 'No previous step to go back to',
    yourExecutionNotes: 'Your notes about this execution',
    addNotes: 'Something worth mentioning (optional)',
    confirmStartExecution: 'Start Process Execution',
    confirmStartExecutionMessage: 'You are about to start executing this process. Do you want to continue?',
    errorDetails: 'Error Details',
    completeExecution: 'Complete Execution',
    executionCompleted: 'Execution marked as Completed',
    executionFailed: 'Execution marked as Failed',
    executionCancelled: 'Execution marked as Cancelled',
    emptyContainerStepsWarning: 'Cannot start execution. The following steps have no substeps configured: {steps}',
    selectExecutionStatus: 'Select Execution Status',
    selectExecutionStatusMessage: 'Some steps were not completed or had errors. How would you like to mark this execution?',
    markAsCompleted: 'Mark as Completed',
    markAsFailed: 'Mark as Failed',
    markAsCancelled: 'Mark as Cancelled',
    closeExecution: 'Close',
    lastExecution: 'Executed on',
    updatedOn: 'Updated on',
    recentlyUpdatedTooltip: 'This process was modified in the last month. Please review it carefully.',
    viewAllExecutions: 'View all executions',
    viewExecutions: 'View executions',
    noExecutionsYet: 'No executions yet',
    executionHistory: 'Execution History',
    assignedByMe: 'Assigned By Me',
    assignedTo: 'Assigned to',
    noAssignedExecutions: 'No executions assigned by you',
    startedBy: 'Started by',
    startedByAssignedTo: 'Executed By',
    executedBy: 'Executed by',
    duration: 'Duration',
    viewDetails: 'View Details',
    noSteps: 'No steps recorded',
    startExecutingProcesses: 'Start executing processes to see their history here',
    forExecution: 'For Execution',
    markStuckExecutionAsCompletedTooltip: 'Mark this execution as completed',
    markStuckExecutionAsFailedTooltip: 'Mark this execution as failed',
    markStuckExecutionAsCancelledTooltip: 'Mark this execution as cancelled',
    stepControl: 'How do you know this was executed?',
    confirmationType: 'Confirmation Type',
    confirmationTypeNone: 'Just an optional comment',
    confirmationTypeBoolean: 'Optional comment plus an explicit confirmation',
    confirmationTypeCustomText: 'Optional comment plus request for some info',
    confirmationQuestion: 'Confirmation Question',
    checkboxControlLabel: 'What the user must confirm',
    customTextLabel: 'What information must the user provide?',
    confirmationQuestionPlaceholder: 'e.g., "Enter the transaction number from the payment system:"',
    confirmationQuestionBooleanPlaceholder: 'e.g., "Have you reviewed and approved the contract?"',
    confirmationRequired: 'Please confirm that',
    confirmationResponse: 'Confirmation',
    confirmed: 'Confirmed',
    notConfirmed: 'Not confirmed',
    confirmationCheckRequired: 'Please check the box to complete this step',
    confirmationTextRequired: 'Please provide the required confirmation',
    requireConfirmation: 'Require confirmation?',
    print: 'Print',
    printProcess: 'Print Process',
    printPreview: 'Print Preview',
    linkedProcessOpensInNewTab: 'Linked process will open in a new tab to preserve current execution',
    versionHistory: 'Version History',
    versionHistoryTooltip: 'Your list of versions of this document',
    version: 'Version',
    versionColumnTooltip: 'Minor and major jumps are determined according to your changes',
    currentVersion: 'Current Version',
    active: 'Active',
    activeVersionTooltip: 'Changes done within the next few hours will be included in this version',
    versionCreatedBy: 'Created by',
    versionDescription: 'Change Description',
    versionCreated: 'Version {version} created',
    showAllExecutions: 'Show all',
    searchByUser: 'Search by user',
    filterByUser: 'Filter by user',
    filterByProcess: 'Filter by process',
    searchByProcess: 'Search by process',
    filterByArea: 'Filter by area',
    searchByArea: 'Search by area',
    filterByService: 'Filter by service',
    searchByService: 'Search by service',
    filterByDate: 'Filter by date',
    includedExecutionDates: 'Included execution dates',
    filterByStatus: 'Filter by status',
    filters: 'Filters',
    statuses: 'Statuses',
    multiple: 'Multiple',
    users: 'Users',
    processes: 'Processes',
    areas: 'Areas',
    services: 'Services',
    allTime: 'All',
    today: 'Today',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    customRange: 'Custom',
    assigned: 'Assigned',
    in_progress: 'In Progress',
    failed: 'Failed',
    cancelled: 'Cancelled',
    skipped: 'Skipped',
    from: 'From',
    to: 'To',
    clearFilters: 'Clear filters',
    noExecutionsMatchingFilters: 'No executions matching the selected filters',
    groupByProcess: 'Group by process',
    groupByUser: 'Group by user',
    executionsForUser: 'Executions for',
    myExecutions: 'My Executions',
    myExecutionHistory: 'My Execution History',
    clearFilter: 'Clear filter',
    executionByAnotherUser: 'Execution by another user',
    redactedExecution: 'Details hidden',
    requestExecution: 'Request Execution',
    requestExecutionTitle: 'Request Execution',
    selectAssignee: 'Select Assignee',
    selectUserToExecuteProcess: 'Select a user to assign this process execution to',
    executionRequestedSuccessfully: 'Execution requested successfully',
    selectUserBeforeRequesting: 'Please select a user',
    errorRequestingExecution: 'Error requesting execution',
    noUsersAvailable: 'No users available to assign',
    notifyAssigneeByEmail: 'Notify assignee by email',
    addNoteOptional: 'Add a note (optional)',
    notePlaceholder: 'Write a message for the assignee...',
    startAssignedExecution: 'Start',
    continueExecution: 'Continue',
    noteFromAssigner: 'Note from Assigner',
    startFresh: 'Start Fresh',
    pendingActions: 'My Pending Actions',
    pendingActionsTooltip: 'Executions assigned to you or that you started and are currently in progress',
    myExecutionHistoryTooltip: 'Your executions across all statuses. Use status filters to narrow down',
    myWatchlistTooltip: 'Executions from processes you are watching and executions you assigned to others',
    allExecutionsTooltip: 'All executions in the organization. Use filters to narrow down by process, user, status, area, service, or date',
    tabsView: 'Tabs View',
    stackedView: 'Stacked View',
    executionControl: 'Execution Control',
    myWatchlist: 'My Watchlist',
    addToWatchlist: 'Add to Watchlist',
    removeFromWatchlist: 'Remove from Watchlist',
    addedToWatchlist: 'Successfully added to watchlist',
    removedFromWatchlist: 'Successfully removed from watchlist',
    watchingProcess: 'Watching this process',
    processWatchlistTooltip: 'Get notified about executions of this process',
    allExecutions: 'All Executions',
    assignedBy: 'Assigned By',
    assignedToYou: 'Assigned to you',
    continuingPreviousExecution: 'Continuing your previous execution',
    startingAssignedExecution: 'Starting your assigned execution',
    confirmStartAssignedExecution: 'Start Assigned Execution',
    confirmContinueExecution: 'Continue Execution',
    confirmStartAssignedExecutionMessage: 'You have an execution assigned to you. Would you like to start it now?',
    confirmContinueExecutionMessage: 'You have an execution in progress started on',
    continueOrStartNew: 'Would you like to continue or start a new one?',
    startOver: 'Start Over',
    startOverTooltip: 'Mark the old one as cancelled and start over',
    iteration: 'Iteration',
    completed: 'Completed',
    addAnotherIteration: 'Repeat for Another',
    doneNoMore: 'Continue to next step',
    repeatStep: 'Repeat Step',
    switchStep: 'Switch Step',
    skipExecution: 'Skip Steps',
    skipExecutionMessage: 'Select the steps you want to skip. You can optionally add notes.',
    noSkippableSteps: 'No steps available to skip',
    selectAll: 'Select all',
    unnamedStep: 'Unnamed step',
    skipExecutionNotesPlaceholder: 'Optional notes about why these steps are being skipped...',
    cancel: 'Cancel',
    skipping: 'Skipping...',
    skipSelected: 'Skip Selected',
    skip: 'Skip',
    missingTriggerId: 'Missing trigger ID. Please check your link.',
    executionSkippedSuccess: 'Execution skipped successfully for today.',
    executionSkippedError: 'Failed to skip execution.',
    processingSkip: 'Processing Skip Request',
    pleaseWait: 'Please wait...',
    executionSkipped: 'Execution Skipped',
    skipFailed: 'Skip Failed',
    saveFirstStepBeforeAdding: 'Save the current step before adding more',
  },
  processForm: {
    name: 'What is this process called?',
    goal: 'What is the goal of this process?',
    category: 'How should this process be categorized?',
    description: 'Describe what this process does',
    calenEvTriggers: 'Calendar / Event Triggers',
    evTrig: 'Event Trigger',
    evTrigName: 'Event Trigger Name',
    evTrigNamePlaceholder: 'An email from a customer',
    evTrigDescription: 'Trigger Description (Optional)',
    calTrig: 'Calendar Trigger',
    triggeredFrom: 'Triggered From these processes',
    createProcess: 'Create Process',
    moveProcessTooltip: 'Click here to move the process to another area/service',
    editProcess: 'Edit Process',
    serviceForProcess: 'Which service contains this process?',
    selectService: 'Select service',
    stepName: 'What happens here (step name)',
    caseName: 'Case Name',
    loopName: 'Loop Name',
    conditionName: 'Condition Name',
    linkedProcess: 'Does another process need to be executed?',
    selectProcess: 'Select a Process',
    stepNotes: 'Extra notes and clarifications',
    stepNotesExplain: 'Add any helpful context, reminders, or clarifications',
    stepCondition: 'Does this step depend on a condition?',
    stepConditionExplain: 'Specify any conditions that must be met for this step',
    stepContent: 'Describe how to do it',
    stepContentTooltip: 'Write a clear explanation of how to carry out this step. Use bullet points for clarity',
    stepInformationPre: 'Describe ',
    stepInformationBold: 'what',
    stepInformationPost: ' to do',
    conditionInformation: 'Describe this condition',
    caseInformation: 'Describe this case',
    loopInformation: 'Describe what repeats',
    removeStep: 'Remove Step',
    firstStepRequired: 'A process must have at least one step, please save it',
    unsavedStepChanges: 'Unsaved Changes',
    unsavedStepChangesMessage: 'You have unsaved changes in the current step. What would you like to do?',
    discardAndAddNew: 'Discard changes and add new',
    saveAndAddNew: 'Save & Add New',
    saveAndSelect: 'Save & Move to selected step',
    discardAndSelect: 'Discard & Move to selected step',
    continueEditing: 'Continue Editing',
    linkedPolicy: 'Which policies apply to this process?',
    linkedPolicyMessage:
      'Select the policies that govern or guide this process. You can select multiple policies.',
    processCategoryMessage: 'Group this process with related processes in a workflow',
    processGoalMessage: 'What is the end result or objective of this process?',
    processDescriptionMessage: 'Briefly explain what this process does',
    processName: 'Process Name',
    saveBeforeTriggers: 'Save the process before adding triggers',
  },
  calTrig: {
    name: 'Calendar Trigger Name',
    namePlaceholder: 'Monthly Budget Review',
    monthlyReminder: 'Monthly Reminder',
    startTime: 'Start Time',
    endTime: 'End Time',
    timezone: 'Timezone',
    assignees: 'Assignees (comma separated)',
    assigneesPlaceholder: 'Enter email addresses separated by commas',
    selectFromOrganization: 'Select Assignees from your Organization:',
    selectMember: 'Select a member',
    noRepeat: 'Only runs once',
    currentSelection: 'Current selection:',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    day: 'Day',
    days: 'Days',
    week: 'Week',
    weeks: 'Weeks',
    year: 'Year',
    years: 'Years',
    dayCriteria: 'Day Criteria',
    byNumber: 'By Day Number',
    byNumberMonth: 'By Day Number of Month',
    byDay: 'By Day of Week',
    byDayMonth: 'By Day of Week of Month',
    month: 'Month',
    repeatEvery: 'Repeat Every',
    repeatFor: 'Repeat Every',
    repeatBy: 'Repeat By',
    number: 'Number',
    frequency: 'Frequency',
    onDays: 'On Days',
    repeatUntil: 'Repeat Until',
    repeatPattern: 'Repeat',
    repeatPosition: 'Repeat Position',
    months: 'Months',
    every: 'Every',
    indefinitely: 'Indefinitely',
    afterTimes: 'End After X Times',
    atDate: 'At Date',
    repeat: 'When is this trigger repeated?',
    repeatTooltip: 'Select a repeat pattern for this trigger. Choose from common patterns like daily, weekly, or monthly, or customize your own pattern.',
    triggerOneLine: 'Trigger one-line description',
    triggerOneLineTooltip: 'A brief, descriptive name for this calendar trigger (e.g., \'Weekly team meeting\', \'Monthly review\')',
    triggerDetails: 'Trigger details',
    triggerDetailsPlaceholder: 'Optional additional details about this trigger',
    triggerDetailsTooltip: 'Additional context, notes, or instructions for this calendar trigger. This is optional but can help clarify the trigger\'s purpose.',
    start: 'Start',
    end: 'End',
    onThe: 'On the',
    dayLabel: 'Same date each month',
    weekdayLabel: 'Same weekday each month',
    times: 'Times',
    date: 'Date',
    remindAssignee: 'Make Mr. Wolf Remind the Assignee',
    reminderInterval: 'Reminder Interval',
    reminderIntervalValue: 'Send reminder after',
    reminderUnit: 'Time Unit',
    reminderHelpText: 'If the assignee has not executed the process, Mr. Wolf will send a reminder.',
    reminderMinutes: 'Minutes',
    reminderHours: 'Hours',
    reminderDays: 'Days',
    intervalMustBePositive: 'Interval must be greater than 0',
    // Preset option labels
    sevenDays: '7 days',
    onlyWeekdays: 'only weekdays',
    onDay: 'on day {day}',
    until: 'until',
    // Day names for recurrence display
    dayNames: {
      MO: 'Monday',
      TU: 'Tuesday',
      WE: 'Wednesday',
      TH: 'Thursday',
      FR: 'Friday',
      SA: 'Saturday',
      SU: 'Sunday',
    },
    // Month names for recurrence display
    monthNames: {
      '1': 'January',
      '2': 'February',
      '3': 'March',
      '4': 'April',
      '5': 'May',
      '6': 'June',
      '7': 'July',
      '8': 'August',
      '9': 'September',
      '10': 'October',
      '11': 'November',
      '12': 'December',
    },
    // Position names for recurrence display
    positionNames: {
      '1': 'First',
      '2': 'Second',
      '3': 'Third',
      '4': 'Fourth',
      '-1': 'Last',
    },
    // Recurrence text patterns
    recurrencePatterns: {
      everyDay: 'Every {interval} day',
      everyDays: 'Every {interval} days',
      everyWeekOn: 'Every {interval} week on {days}',
      everyWeeksOn: 'Every {interval} weeks on {days}',
      everyMonthOnDay: 'Every {interval} month on day {day}',
      everyMonthsOnDay: 'Every {interval} months on day {day}',
      everyMonthOnThe: 'Every {interval} month on the {position} {day}',
      everyMonthsOnThe: 'Every {interval} months on the {position} {day}',
      everyYearOn: 'Every {interval} year on {month} {day}',
      everyYearsOn: 'Every {interval} years on {month} {day}',
      everyYearOnThe: 'Every {interval} year on the {position} {day} of {month}',
      everyYearsOnThe: 'Every {interval} years on the {position} {day} of {month}',
      noRepetition: 'No repetition',
      and: 'and',
    },
  },
  processMap: {
    title: 'Process Map',
    bezier: 'Bezier',
    straight: 'Straight',
    step: 'Step',
    lineStyle: 'Line Style',
    chartDetail: 'Chart detail level',
    detailedProcessLevel: 'Show detailed processes with steps inside',
    roughOutlineLevel: 'Show rough outline',
    v2: 'Show v2!',
    flowMargin: 'Flow Margin (px) - Vertical space between categories',
    categoriesAdded: 'Currently drawn categories',
    categoriesAddedTooltip: 'Drag categories to reorder them',
    selectService: 'Select Service',
    selectArea: 'Select Area',
    selectCategory: 'Select Category',
    noCategoriesAddedYet: 'No categories added yet',
    noTriggersYet: 'No triggers defined for this flow',
    selectAProcess: 'Select a category from the menu (or click the process map icon in cards) to see something here!',
    noConnectionsWarning: 'No connections with other processes in this category',
    noTriggerDefined: 'No trigger defined',
    warning: 'Warning',
    addFlowTooltip: 'Add the flow containing this process to the graph',
    showFlowTooltip: 'Show the flow containing this process (if it exists)',
    collapse: 'Collapse',
    showAllSteps: 'Show all steps',
    searchPlaceholder: 'Search...',
    expandCollapseMenu: 'Expand/Collapse menu',
    processLinkedToItself: 'Process linked to itself',
    processPartOfLoop: 'Process is part of a circular loop',
    processDraft: 'This process is still a Draft',
  },
  services: {
    title: 'Services',
    addNew: 'Add New Service',
    edit: 'Edit Service',
    areaForService: 'Which area does this service belong to?',
    selectArea: 'Select area',
    createService: 'Create Service',
    editService: 'Edit Service',
    processesInside: 'Processes within this Service',
    pickAreaToSeeColors: 'Select an area first to see available colors',
    selectAColorArea: 'Pick a color to identify this area. Services inside will use shades of this color.',
    selectAColorService: 'Pick a color to identify this service and its processes',
    emptyServiceMessage: 'There are no services to show yet.',
    createAreaFirst: 'You need to create areas first',
    name: 'What is this service called?',
    description: 'Describe what this service does',
    color: 'What color should represent this service?',
  },
  stepItem: {
    notes: 'Notes (Optional)',
    selectProcess: 'Select Process',
    condition: 'Condition',
    conditionPlaceholder: 'If the reviewed item is not approved',
    requiredWithin: 'Required for steps within switch',
    linkedProcess: 'Linked Process',
    linkedProcessTiming: 'When does this process get executed?',
    linkedProcessTimingTooltip: 'When will the linked process be triggered: immediately, after a scheduled event, after a message is received, or after something else',
    linkedProcessMed: 'Linked Process Mediated by',
    deleteStep: 'Delete Step',
    editStep: 'Edit Step',
    dragStep: 'Drag Step',
    immediate: 'Immediately',
    linkEmail: 'After a message',
    linkCalendar: 'After a scheduled event',
    linkOther: 'After something else',
    triggerNameMessage: 'What is this message?',
    triggerNameMessageTooltip: 'Name of the message that triggers this process (e.g., "Approval email from manager", "Customer inquiry")',
    triggerNameCalendar: 'What is this scheduled event?',
    triggerNameCalendarTooltip: 'Name of the calendar event that triggers this process (e.g., "Monthly review meeting", "Quarterly audit")',
    triggerNameOther: 'What is this event?',
    triggerNameOtherTooltip: 'Name of the event that triggers this process (e.g., "System alert", "Manual request")',
    triggerDescriptionMessage: 'Describe the message',
    triggerDescriptionMessageTooltip: 'Provide more details about the message content or sender',
    triggerDescriptionCalendar: 'Describe the scheduled event',
    triggerDescriptionCalendarTooltip: 'Provide more details about when and how this event occurs',
    triggerDescriptionOther: 'Describe the event',
    triggerDescriptionOtherTooltip: 'Provide more details about what this event is and when it happens',
    conditionRequired: 'Condition is required for this step',
  },
  summaryCardProcess: {
    cannotReorder: 'Cannot reorder in processes from all services view, access a specific service to reorder',
    selectPolicy: 'Select Policy',
    noTriggers: 'No calendar / event triggers',
    noPolicies: 'No policies linked',
  },
  summaryCard: {
    cannotReorder: 'Cannot reorder in services from all areas view, access a specific area to reorder',
    integration: 'Integration',
    integrationInactiveMessage: 'You do not have an active integration',
    integrationOfferMessage: 'Would you like to set up your integration now?',
    emptyArea: 'This area contains no services inside',
    emptyService: 'This service contains no processes inside',
    emptyProcess: 'This process contains no steps inside',
    numberPolicies: 'Number of Policies linked to this process',
    numberCalendarTriggers: 'Number of Calendar Triggers for this process',
    numberEventTriggers: 'Number of Event Triggers for this process',
  },
  impExp: {
    enterData: 'Enter Data to be imported',
    resetIds: 'Reset IDs',
    resetInteg: 'Reset Integration Data',
    skipReorder: 'Skip Reorder',
    importPos: 'Import Position',
    beforeStep: 'Before Step',
    integDataMessage:
      'Note that disabling this will maintain integration data from the imported JSON, possibly creating inconsistencies',
    exportElem: 'Select Elements to Export',
  },
  menu: {
    areas: 'Areas',
    services: 'Services',
    categories: 'Categories',
    processes: 'Processes',
    policies: 'Policies',
    documents: 'Documents',
    processMap: 'Process Map',
    integrations: 'Integrations',
    discrepancies: 'Discrepancies',
    executions: 'Executions',
    organizations: 'Organizations',
    settings: 'Profile',
    myOrganization: 'My Organization',
    switchOrganization: 'Switch Organization',
    createOrganization: 'Create Organization',
    logout: 'Logout',
    users: 'Users',
    searchResultsMinLength: 'Type at least three characters',
    noResults: 'No results found.',
    stopImpersonate: 'Stop Impersonating',
    workingAs: 'Warning: currently working as',
    ifReload: 'If you reload the page, you will stop impersonating automatically',
    stopImpersonating: 'To allow collapse, first stop impersonating',
    onboarding: 'Onboarding',
    onboardingTasksCompleted: 'Onboarding Tasks completed',
    ftueCompleted: 'Interview Done',
    processCreated: 'Process Created',
    userCreated: 'User Created',
    executionRequested: 'Execution Requested',
    triggerAdded: 'Trigger Added',
    createProcessFirst: 'You must create a process first',
    createUserFirst: 'You must create a user first',
    dismissPermanently: 'Dismiss Permanently',
    dismissForTwoWeeks: 'Dismiss for 2 Weeks',
    dismissOnboarding: 'Dismiss Onboarding',
    dismissOnboardingText:
      'Are you sure you want to dismiss the onboarding steps reminder? Select if you wish to dismiss it permanently or for two weeks.',
    updateProfile: 'Your profile is more than 90 days old, we recommend going to "My organization" to update it.',
    collapseTooltip: 'Click to collapse sidebar',
    expandTooltip: 'Click to expand sidebar',
    searchTooltip: 'Click to search for processes, areas, services, etc.',
    reportIssue: 'Report Issue',
    onboardingProgress: 'Onboarding Progress',
    billing: 'Billing',
    subscriptions: 'Subscriptions',
    viewFeedback: 'View Feedback',
  },
  feedback: {
    title: 'Send Feedback',
    pageTitle: 'User Feedback',
    ratingLabel: 'Rating (optional)',
    typeLabel: 'Feedback Type',
    commentLabel: 'Comment (optional)',
    commentPlaceholder: 'Tell us what you think...',
    minCommentLength: 'Comment must be at least 5 characters',
    typeBug: 'Bug Report',
    typeComment: 'Comment',
    typeSuggestion: 'Suggestion',
    typeFeatureRequest: 'Feature Request',
    typeImprovement: 'Improvement Suggestion',
    typeOther: 'Other',
    tableUser: 'User',
    tableType: 'Type',
    tableRating: 'Rating',
    tableComment: 'Comment',
    tableDate: 'Date',
    noFeedback: 'No feedback submissions yet',
  },
  settings: {
    changeAvatar: 'Change Avatar',
    saveAvatar: 'Save Avatar',
    changePassword: 'Change Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    updatePassword: 'Update Password',
    saveName: 'Save Name',
    language: 'Language',
    saveLanguage: 'Save Language',
    english: 'English',
    spanish: 'Spanish',
    seeOrganizationData: 'See Organization Data',
    serviceStatus: 'Service Status',
    wolfieStatus: 'Mr. Wolf Chat Status',
    wolfieSuggestions: 'Mr. Wolf Chat Show Message Suggestions',
    wolfieVoiceMode: 'Mr. Wolf Chat Voice Mode',
    wolfieAvatarMode: 'Mr. Wolf Chat Avatar Mode',
    wolfieDevPanel: 'Mr. Wolf Developer Panel',
    voiceMode: 'Voice Mode',
    avatarMode: 'Avatar Mode',
    configuration: 'Configuration',
    profile: 'Profile',
    goToOrganization: 'Go to Organization Details',
    editName: 'Edit Name',
    autoEnableMic: 'Auto Enable Mic After Reply',
    voiceActivation: 'Voice Activation',
    manualOrgUpdate: 'Manual Organization Update',
    defaultOrganization: 'Default Organization',
    defaultOrganizationUpdated: 'Default organization updated successfully',
    yourOrganization: 'Your Organization',
    yourOrganizations: 'Your Organizations',
    sessionRecording: 'Session Recording',
    sessionRecordingUpdated: 'Session recording preference updated successfully',
    profileInformation: 'Profile Information',
    organizationsManagement: 'Organizations',
    generalSettings: 'General Settings',
    developerSettings: 'Developer Settings',
    currentOrganization: 'Current',
    switchToOrganization: 'Switch',
    leaveOrganization: 'Leave',
    editOrganization: 'Edit Org',
    noOrganizations: 'No organizations found',
    changePasswordDescription: 'Update your account password',
    sessionRecordingDescription: 'Manage session recording preferences',
    serviceStatusDescription: 'View system health and status',
    wolfieStatusDescription: 'Enable or disable Mr. Wolf assistant',
    autoEnableMicDescription: 'Automatically enable microphone after Mr. Wolf replies',
    voiceActivationDescription: 'Enable wake word detection for hands-free interaction',
    voiceModeDescription: 'Enable text-to-speech for Mr. Wolf responses',
    avatarModeDescription: 'Show animated avatar with Mr. Wolf',
    wolfieDevPanelDescription: 'Show developer tools for debugging Mr. Wolf',
    manualOrgUpdateDescription: 'Manually trigger organization data update for AI',
    manualOrgUpdateAllDescription: 'Manually trigger data update for all organizations',
    manualOrgUpdateAll: 'Manual Update All Organizations',
    updateNow: 'Update Now',
    updateAllNow: 'Update All Now',
    viewStatus: 'View Status',
    launchTutorial: 'Launch Tutorial',
    launchTutorialDescription: 'Restart the interactive tutorial to learn the basics',
    startTutorial: 'Start Tutorial',
    emailPreferences: 'Email Preferences',
    emailPreferencesUpdated: 'Email preferences updated successfully',
    marketingEmails: 'Marketing Emails',
    marketingEmailsDescription: 'Receive news, updates, and promotional content',
    processReminders: 'Process Reminders',
    processRemindersDescription: 'Receive reminders about scheduled processes and deadlines',
    assignmentNotifications: 'Assignment Notifications',
    assignmentNotificationsDescription: 'Receive notifications when you are assigned to a process or task',
    organizationUpdates: 'Organization Updates',
    organizationUpdatesDescription: 'Receive notifications when you are added to or removed from an organization',
    // New notification preferences
    notificationPreferences: 'Notification Preferences',
    notificationPreferencesUpdated: 'Notification preferences updated successfully',
    notificationChannelMail: 'Mail',
    notificationChannelBadge: 'Badge',
    notificationChannelSlack: 'Slack',
    underImplementation: 'Under implementation',
    sharedBadgeTooltip: 'This badge is shared with related notifications',
    // Marketing Notifications
    marketingNotifications: 'Marketing Notifications',
    marketingNotificationsDescription: 'Receive news, updates, and promotional content',
    // Assignment Notifications
    assignmentNotificationsTitle: 'Assignment Notifications',
    assignmentNotificationsDesc: 'Receive notifications when you are assigned to a process execution',
    // Execution Reminders
    executionReminders: 'Execution Reminders',
    executionRemindersDescription: 'Receive reminders about pending execution assignments',
    // Organization Changes
    organizationChanges: 'Organization Changes',
    organizationChangesDescription: 'Receive notifications about organization updates',
    // Discrepancies
    discrepancies: 'Discrepancies',
    discrepanciesDescription: 'Receive notifications about process discrepancies',
    // Wolf Pendings
    wolfPendings: 'Mr. Wolf Pendings',
    wolfPendingsDescription: 'Receive notifications about pending items from Mr. Wolf',
    // Calendar Trigger Now
    calendarTrigger: 'Calendar Trigger Now',
    calendarTriggerDescription: 'Receive notifications when calendar triggers fire',
    slackNotConnected: 'Admin must connect Slack first',
  },
  tutorial: {
    nextStep: 'Next',
    previousStep: 'Back',
    skipTutorial: 'Skip Tour',
    getStarted: 'Get Started',
    gotIt: 'Got it',
    stepCounter: 'Step {current} of {total}',
    tutorialCompleted: 'Tutorial completed!',
    unableToCompleteTutorial: 'Unable to complete tutorial. Please ensure you have at least one process created.',
    welcome: {
      title: 'Welcome to Mr. Wolf!',
      content: "Quick tour of the app. Let's go!",
    },
    sidebar: {
      title: 'Navigation',
      content: 'Use this sidebar to navigate between Processes, Executions, Process Map, and more.',
    },
    executions: {
      title: 'Executions',
      content: 'Track and manage process executions assigned to you or your team.',
    },
    requestExecution: {
      title: 'Request Execution',
      content: 'Click here to request a new execution of this process and assign it to a team member.',
    },
    processes: {
      title: 'Processes',
      content: 'Step-by-step procedures that define how work gets done in your organization.',
    },
    processDescriptionSidebar: {
      title: 'Process Sidebar',
      content: 'The sidebar shows the process goal, category, and all steps. Click on any step to view its details.',
    },
    processDescriptionContent: {
      title: 'Step Details',
      content: 'The main area shows the detailed information for each step, including descriptions, notes, and actions.',
    },
    triggers: {
      title: 'Triggers',
      content: 'Triggers define when a process execution should happen. Event triggers respond to specific events, while Calendar triggers schedule executions at set times.',
    },
    executeButton: {
      title: 'Execute Process',
      content: 'Click here to start executing this process yourself. Track your progress as you complete each step.',
    },
    processMapOverview: {
      title: 'Process Map',
      content: 'The Process Map provides a visual overview of all your processes organized by category. You can filter, search, and navigate through your organization\'s processes.',
    },
    processMapFilters: {
      title: 'Selection Menu',
      content: 'Use this menu to select which Areas, Services, and Categories to display on your process map.',
    },
    completion: {
      title: "You're Ready!",
      content: 'Explore Processes, request Executions, and use the Process Map to visualize your workflows. Restart this tour anytime from Settings.',
    },
  },
  paywall: {
    currentlyFreeTierPlan: 'Currently in Free Tier Plan',
    paywallErrorDescription: 'Your plan only includes one admin and one read-only user',
    upgradeTitle: 'Upgrade to Professional Plan',
    upgradeSubtitle: 'Ideal for teams seeking unlimited collaboration and optimized management.',
    includes: 'Includes',
    allFreeTierFeatures: 'All Free Tier Features',
    additionalUsers: 'Additional users as needed',
    switchAnytime: 'Flexible scaling\n(add and remove seats at any time)',
    adminUserPrice: '$15',
    adminUserPriceDescription: 'per admin user/month',
    readOnlyUserPrice: '$10',
    readOnlyUserPriceDescription: 'read-only user/month',
    cta: 'Upgrade plan',
  },
  seats: {
    noSeatsAvailable: 'No Seats Available',
    noSeatsDescription: 'You do not have seats available.',
    noAdminSeatsAvailable: 'No Admin Seats Available',
    noAdminSeatsDescription: 'You do not have admin seats available.',
    noUserSeatsAvailable: 'No User Seats Available',
    noUserSeatsDescription: 'You do not have user seats available.',
    addMoreSeatsTitle: 'Add More Seats',
    addMoreSeatsSubtitle: 'Scale your team by adding more seats to your plan.',
    addMoreAdminSeatsTitle: 'Add More Admin Seats',
    addMoreAdminSeatsSubtitle: 'You need to add more admin seats to assign this role. Go to the billing page to add admin seats to your subscription.',
    addMoreUserSeatsTitle: 'Add More User Seats',
    addMoreUserSeatsSubtitle: 'You need to add more user seats to assign this role. Go to the billing page to add user seats to your subscription.',
    flexibleScaling: 'Flexible seat scaling',
    instantAccess: 'Instant access for new users',
    cancelAnytime: 'Cancel anytime',
    proRatedBilling: 'Pro-rated billing',
    addSeats: 'Add Seats',
    addAdminSeats: 'Add Admin Seats',
    addUserSeats: 'Add User Seats',
  },
  common: {
    accept: 'Accept',
    action: 'Action',
    actions: 'Actions',
    active: 'Active',
    add: 'Add',
    alert: 'Alert',
    all: 'All',
    allAreas: 'All Areas',
    alreadyEditing: 'You are already editing a step, either cancel or save the edition. You are editing the step: ',
    area: 'Area',
    areas: 'Areas',
    assign: 'Assign',
    back: 'Back',
    beginning: 'Beginning',
    cancel: 'Cancel',
    cannotDelete: 'Cannot delete if there are related entities',
    case: 'Case',
    category: 'Category',
    calendarIntegration: 'Calendar Integration Active',
    changesNotSaved: 'Your changes have not been saved yet.',
    cancelAndStayHere: 'Cancel',
    saveAndLeave: 'Save',
    backToEditing: 'Back to Editing',
    discardChanges: 'Discard Changes',
    change: "Change",
    clear: 'Clear',
    clickDelete: 'Click here to delete',
    clickEdit: 'Click here to edit',
    clickShowDoc: 'Click to show in google docs',
    clickShowMap: 'Click to show in process map',
    clickShowStorage: 'Click to show in storage integration',
    clickShowCalendar: 'Click to show in calendar integration',
    clickTo: 'Click to',
    clickToAddOne: 'Click here to add one.',
    clickToAttachWolfie: 'Click to attach a file to use as an input for Mr. Wolf (Max size 5 MB)',
    clickView: 'Click here to view',
    clickViewGrid: 'Click to view in grid',
    clickViewList: 'Click to view in list',
    clone: 'Clone',
    close: 'Close',
    collapse: 'Collapse',
    color: 'Color',
    condition: 'Condition',
    confirm: 'Confirm',
    confirmLeave: 'Confirm Leave',
    date: 'Date',
    deleteProcess: 'Delete Process',
    deleteProcessConfirmation: 'This will delete all related steps and triggers and <strong>cannot be undone</strong>.',
    deleteProcessQuestion: 'Are you sure you want to proceed?',
    yesDelete: 'Yes, Delete',
    comingSoon: 'Coming Soon',
    comingSoonDescription: 'This feature is not yet available, please check back later.',
    content: 'Content',
    create: 'Create',
    custom: 'Custom',
    delete: 'Delete',
    deleted: 'Deleted',
    description: 'Description',
    disable: 'Disable',
    disabled: 'Disabled',
    documents: 'Documents',
    dragToReorder: 'Drag to reorder',
    edit: 'Edit',
    email: 'Email',
    enable: 'Enable',
    enabled: 'Enabled',
    end: 'End',
    expand: 'Expand',
    export: 'Export',
    favorites: 'Favorites',
    filter: 'Filter',
    goal: 'Goal',
    help: 'Help',
    import: 'Import',
    impersonate: 'Impersonate',
    inside: 'Inside',
    link: 'Link',
    loop: 'Loop',
    moveInside: 'Move Inside',
    moveOutside: 'Move Outside',
    name: 'Name',
    none: 'None',
    notNow: 'Not Now',
    openDrawer: 'Open Drawer',
    openInNewTab: 'Open in new tab',
    optional: 'Optional',
    options: 'Options',
    organization: 'Organization',
    owner: 'Owner',
    owners: 'Owners',
    policy: 'Policy',
    policies: 'Policies',
    preview: 'Preview',
    process: 'Process',
    processMap: 'Process Map',
    report: 'Report',
    requestError: 'Network request failed',
    requestSuccess: 'Request successful',
    required: 'Required',
    somethingWentWrong: 'Something went wrong, please refresh and try again.',
    save: 'Save',
    saving: 'Saving',
    search: 'Search',
    select: 'Select',
    send: 'Send',
    service: 'Service',
    share: 'Share',
    show: 'Show',
    showInDocs: 'Show in Google Docs',
    status: 'Status',
    step: 'Step',
    steps: 'Steps',
    allSteps: 'All Steps',
    substeps: 'Substeps',
    of: 'of',
    storageIntegration: 'Storage Integration Active',
    submit: 'Submit',
    suggestions: 'Suggestions',
    toggleEdit: 'Toggle Edit',
    triggers: 'Triggers',
    uncategorized: 'Uncategorized',
    update: 'Update',
    unsaved: 'unsaved',
    withChanges: 'editing',
    uploading: 'Uploading',
    user: 'User',
    wolfie: 'Mr. Wolf',
    yes: 'Yes',
    ok: 'OK',
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    last: 'Last',
  },
  documents: {
    title: 'Documents',
    addDocument: 'Upload document',
    replaceDocument: 'Replace document',
    categoryInUse: 'This category is in use and cannot be deleted',
    upload: 'Upload',
    uploadDocument: 'Upload Document',
    previewText: 'File preview',
    previewUpdateText: 'Preview of the file to be updated (the old version will be REPLACED)',
    noPreview: 'Preview for this file type unavailable',
    confirmDelete: 'Confirm document deletion',
    confirmDeleteMessage: 'Are you sure you want to delete the document?',
    cantDelete: 'This file is linked to the following steps, remove them from steps first',
    documentDisabledSuccessfully: 'Document deleted successfully',
    documentUpdatedSuccessfully: 'Document updated successfully',
    downloadFile: 'Download File',
    owner: 'Owner',
    replaceWithNew: 'Replace this file with a new one (this will keep the same ID and existing links)',
    documentCategories: 'Document Categories',
    documentPreview: 'Document Preview',
    noVideoTag: 'Your browser does not support the video tag.',
  },
  organizations: {
    title: 'Organizations',
    organization: 'Organization',
    userInfo: 'User Information',
    ownersNames: 'Owners Names',
    ownersEmails: 'Owners Emails',
    addOrganization: 'Add Organization',
    editOrganization: 'Edit Organization',
    create: 'Create',
    enableOrganization: 'Enable Organization',
    disableOrganization: 'Disable Organization',
    confirmDisableMessage: 'Are you sure that you want to disable the organization?',
    confirmEnableMessage: 'Are you sure that you want to enable the organization?',
    lastProfileUpdate: 'Last Profile Update',
    mainAreas: 'Main Areas',
    troublesomeProcesses: 'Troublesome Processes',
    onboardingStatus: 'Onboarding Status',
    skippedUntil: 'Skipped Until',
    redoFTUE: 'Relaunch Interview',
    redoFTUEDescription: 'Relaunch the interview to update your organization data',
    interviewProfile: 'Interview Profile',
    showOrganizationData: 'Click to show organization profile page',
    pendingActions: 'Pending Actions',
    processCreation: 'Process Creation',
    stepCreation: 'Step Creation',
    shortDescriptionWarning: 'We would do better with a longer description',
    shortDescriptionMessage: 'A detailed description helps team members understand the organization\'s purpose and goals. Consider adding more context about what this organization does.',
    goBackAndAddMore: 'Add More Details',
    skipDescription: 'Skip / I Don\'t Care',
    descriptionEncouragement1: 'Great start! A bit more detail would be helpful.',
    descriptionEncouragement2: 'Thanks! Please add some more information.',
    descriptionEncouragement3: 'Sounds like a good start, perhaps there is some more info you can add?',
    descriptionEncouragement4: 'Very good, if you have any more relevant details feel free to add them.',
    descriptionEncouragement5: 'Thanks!',
    seedOrganizationData: 'Seed the organization with initial data',
    seedOrganizationDataTooltip: 'If enabled, example data (areas, services, processes) will be created for this organization to help you get started quickly.',
  },
  users: {
    title: 'Users',
    role: 'Role',
    firstName: 'First Name',
    status: 'Status',
    lastName: 'Last Name',
    addUser: 'Add User',
    disableUser: 'Disable User',
    editUser: 'Edit User',
    confirmDisableMessage: 'Are you sure that you want to disable the user?',
    confirmEnableMessage: 'Are you sure that you want to enable the user?',
    notAllowedToEdit: 'You are not allowed to edit this user',
    firstUserRoleUser: 'The first person you add must have the USER role.',
    ownerRoleModificationRestriction: 'Owner role can only be modified by staff, contact support if you need to change it',
    ownerRoleCannotBeSelected: 'Owner role cannot be selected',
    locale: 'Locale',
    assignSeat: 'Assign Seat',
    revokeSeat: 'Revoke Seat',
    seatAssigned: 'Seat assigned successfully',
    seatRevoked: 'Seat revoked successfully',
    noSeatAvailable: 'No seats available',
    seatType: 'Seat Type',
    adminSeat: 'Admin Seat',
    userSeat: 'User Seat',
    noSeat: 'No Seat',
    assignSeatTitle: 'Assign Seat',
    revokeSeatTitle: 'Revoke Seat',
    assignSeatMessage: 'Are you sure you want to assign a seat to this user?',
    revokeSeatMessage: 'Are you sure you want to revoke the seat from this user?',
    seatError: 'Contact your admin to assign you a seat',
    unableToCreateUsers: 'You cannot create users until you upgrade your plan',
    noSeatsAvailableMessage: 'You do not have seats available.',
    onlyUserSeatsAvailable: 'You can only create "user" roles because those are the only seats available. You can go to billing if you want to add more capacity',
    onlyAdminSeatsAvailable: 'You can only create "admin" roles because those are the only seats available. You can go to billing if you want to add more capacity',
    onlyUserSeatsAvailableRestriction: 'Only USER role is available due to seat limitations. Upgrade your plan to add ADMIN users.',
    onlyAdminSeatsAvailableRestriction: 'Only ADMIN role is available due to seat limitations. Upgrade your plan to add USER seats.',
    goToBilling: 'Click on add seats to go to the billing page and manage your seats',
    upgradePlan: 'Upgrade your plan',
    adminRoleRequiresUpgrade: 'Admin role requires an upgraded plan.',
    seatsLeft: 'seats left',
    failedLoginAttempts: 'Failed Login Attempts',
    resetFailedLoginAttempts: 'Reset failed login attempts',
  },
  userOrganizations: {
    title: 'User Organizations',
    organizationsFor: 'Organizations for',
    addToOrganization: 'Add to Organization',
    loading: 'Loading...',
    noOrganizations: 'This user is not a member of any organizations.',
    currentOrganizations: 'Current Organizations',
    previouslyBelongedTo: 'Previously Belonged To',
    lastRole: 'Last role',
    removed: 'Removed',
    unknown: 'Unknown',
    restoreToOrganization: 'Restore to Organization',
    restore: 'Restore',
    addUserToOrganization: 'Add User to Organization',
    editRole: 'Edit Role',
    removeFromOrganization: 'Remove from Organization',
    ownerRoleCannotBeModified: 'Owner role cannot be modified',
    viewOnlyMessage: 'You can only view user organization information from your current organization context.',
  },
  wolfie: {
    title: "Mr. Wolf's Insights",
    expand: 'Expand',
    collapse: 'Collapse',
    minimize: 'Minimize',
    helpTooltip: 'The bolt to the left triggers the quick commands to start available actions.You can also write "restart" to clean the current active conversation and start over.',
    quickCommands: 'Quick commands',
    attachFileTooltip: 'Attach a file (PDF, DOC, DOCX, TXT) to generate a process from its content',
    quickCommandCreateProcess: 'I want to create a process',
    quickCommandCreateProcessFromFile: 'I want to create a process from an existing file',
    quickCommandWritePolicy: 'I want to write a policy',
    quickCommandKnowOrganization: 'I want to know more about my organization',
    quickCommandRestart: 'Start new conversation',
    loading: 'Working on the answer...',
    send: 'Send (also Ctrl+Enter or Cmd+Enter)',
    talk: 'Enable Mr. Wolf voice',
    mute: 'Mute Mr. Wolf voice',
    enableWakeWord: 'Enable "Hey Mr. Wolf" wake word',
    disableWakeWord: 'Disable "Hey Mr. Wolf" wake word',
    ftueMessage1: 'Welcome to Mr. Wolf',
    ftueMessage2: "Let's start by getting to know your organization.",
    ftueMessage3: 'Mr. Wolf will guide you through a few questions to quickly get a sense of your organization.',
    ftueMessage4: 'Then we will proceed to set up the areas in your organization.',
    ftueMessage5: 'Of course, you can always make changes later and ask Mr.Wolf to adjust the suggested data.',
    ftueCancelButton: 'No thanks, no FTUE',
    ftueStartButton: "OK, let's start!",
    messagePlaceholder: 'Write your message here...',
    stopRecording: 'Click to stop recording (also stops when you are silent for a few seconds)',
    startRecording: 'Click to start recording',
    loadingStage1a: 'Reviewing your message...',
    loadingStage1b: 'Understanding your request...',
    loadingStage1c: 'Processing input...',
    loadingStage2a: 'Checking organization info...',
    loadingStage2b: 'Gathering relevant data...',
    loadingStage2c: 'Searching knowledge base...',
    loadingStage3a: 'Analyzing current processes...',
    loadingStage3b: 'Analyzing context...',
    loadingStage3c: 'Reviewing policies...',
    loadingStage4a: 'Processing your request...',
    loadingStage4b: 'Considering existing structures...',
    loadingStage4c: 'Evaluating alternative answers...',
    loadingStage5a: 'Preparing response...',
    loadingStage5b: 'Finalizing answer...',
    loadingStage5c: 'Almost ready...',
    fileLoadingStage1a: 'Reading your document...',
    fileLoadingStage1b: 'Opening the file...',
    fileLoadingStage1c: 'Scanning document contents...',
    fileLoadingStage2a: 'Extracting text from document...',
    fileLoadingStage2b: 'Parsing document structure...',
    fileLoadingStage2c: 'Analyzing document format...',
    fileLoadingStage3a: 'Identifying process steps...',
    fileLoadingStage3b: 'Looking for procedures...',
    fileLoadingStage3c: 'Detecting workflow patterns...',
    fileLoadingStage4a: 'Structuring the information...',
    fileLoadingStage4b: 'Organizing extracted data...',
    fileLoadingStage4c: 'Building process outline...',
    fileLoadingStage5a: 'Preparing your process...',
    fileLoadingStage5b: 'Finalizing document analysis...',
    fileLoadingStage5c: 'Almost ready with your process...',
    rateLimitError: 'Your quota for interactions with Mr. Wolf has been met. Please try again after {time}.',
    rateLimitWarning: 'You are approaching your interactions quota. You can chat a little longer but then the chat will be paused until the quota is reset in about an hour.',
    moveToTop: 'Move Mr.Wolf Hub to top',
    moveToBottom: 'Move Mr.Wolf Hub to bottom',
    showMessageWindow: 'Show message window',
    hideMessageWindow: 'Hide message window',
    fileSizeError: 'File is too large. Maximum size is 5MB.',
    fileRequiredError: 'Please select a file.',
    processingError: 'There was an error processing your file. Please try again.',
  },
  pricing: {
    cta: {
      readyToGetStarted: 'Ready to get started?',
      tryFreeTier: 'Try the Free tier now or',
      subscribeToProfessional: 'subscribe to Professional to',
      unlockFullPotential: 'unlock the full potential.',
      startForFree: 'Start for Free',
      getProfessional: 'Get Professional',
    },
  },
  footer: {
    home: 'Home',
    learning: 'Learning',
    pricing: 'Pricing',
    aboutUs: 'About us',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    serviceStatus: 'Service Status',
    copyright: '© 2025 Mr.Wolf. All rights reserved.',
  },
  logRocket: {
    title: 'Session Recording Consent',
    description: 'Wolf uses LogRocket to help us understand and fix issues faster by recording limited session data.',
    description2: 'Do you consent to this so we can provide you with better support?',
    accept: 'Yes, sure.',
    decline: 'No.',
    statusAccepted: 'Accepted',
    statusRejected: 'Rejected',
  },
  billing: {
    billing: 'Billing',
    sandboxMode: 'Running in Sandbox Mode',
    noStripeKeyNotice: 'Stripe payment integration is not enabled yet. Billing functionality is not available.',
    organizationInformation: 'Organization Information',
    billingContact: 'Billing Contact',
    role: 'Role',
    currentPlan: 'Current Plan',
    freeTier: 'Free Tier',
    freeTierDescription: 'You are currently on the Free Tier plan. Upgrade to access more features and users.',
    paidSubscription: 'Paid Subscription',
    subscriptionStartDate: 'Start Date',
    manageSubscription: 'Manage Subscription',
    manageSubscriptionDescription: 'Modify your plan or update payment information',
    managePaymentMethod: 'Manage Payment Method',
    managePaymentMethodDescription: 'Update your card or billing information',
    modifyPlan: 'Modify Plan',
    planUpgradeDescription: 'Unlock additional features with a Professional plan',
    upgradePlan: 'Upgrade Plan',
    billingHistory: 'Billing History',
    noBillingHistory: 'No billing history available',
    invoiceDescription: 'Subscription Invoice',
    invoiceId: 'Invoice ID',
    invoiceDate: 'Date',
    modifySubscription: 'Modify Subscription',
    updateSubscription: 'Update Subscription',
    subscriptionUpdatedSuccess: 'Subscription updated successfully',
    cancelSubscription: 'Cancel Subscription',
    cancelSubscriptionTitle: 'Cancel Subscription',
    cancelSubscriptionMessage: 'Are you sure you want to cancel your subscription? Your plan will remain active until the end of the current billing period.',
    cancelSubscriptionWarning: 'Warning: When your subscription ends, all users except the owner and one regular user will be disabled and unable to access the app.',
    cancelImmediatelyLabel: 'Cancel Immediately',
    cancelImmediatelyDescription: 'Cancel now and lose access immediately instead of at the end of the billing period',
    confirmCancel: 'Yes, Cancel Subscription',
    cancelling: 'Cancelling...',
    subscriptionCancelledSuccess: 'Subscription cancelled successfully. It will remain active until the end of the billing period.',
    subscriptionCancelledImmediately: 'Subscription cancelled immediately',
    cancelAtPeriodEndTitle: 'Subscription Ending',
    cancelAtPeriodEndMessage: 'Your subscription is set to cancel at the end of the current billing period. You cannot modify or cancel it during this time.',
    cancelAtPeriodEndInfo: 'You can create a new subscription after the current period ends.',
    createNewSubscription: 'Create New Subscription',
    createNewSubscriptionDescription: 'Your subscription is cancelled. Create a new subscription to continue using the service.',
    selectSeats: 'Select Seats',
    adminSeats: 'Admin Seats',
    userSeats: 'User Seats',
    perSeatMonth: 'seat/month',
    adminSeatsDescription: 'Full access users with admin privileges',
    userSeatsDescription: 'Read-only users with limited access',
    billingEmail: 'Billing Email',
    billingEmailPlaceholder: 'billing@company.com',
    billingEmailHelper: 'Invoices and receipts will be sent to the organization owner\'s email.',
    totalMonthly: 'Total Monthly',
    billingRecurring: 'Billed monthly. Cancel anytime.',
    continueToPayment: 'Continue to Payment',
    priceConfigNotLoaded: 'Price configuration not loaded. Please try again.',
    subscriptionSummary: 'Subscription Summary',
    couponCode: 'Coupon Code',
    couponCodePlaceholder: 'Enter coupon code',
    couponCodeHelper: 'Optional: Enter a promotional code to apply a discount',
    applyCoupon: 'Apply Coupon',
    validateCoupon: 'Validate',
    couponApplied: 'Coupon applied successfully',
    invalidCoupon: 'Invalid coupon code',
    removeCoupon: 'Remove Coupon',
    validatingCoupon: 'Validating...',
    couponValidationSuccess: 'Coupon is valid!',
    couponDiscountApplied: 'Discount Applied',
    originalPrice: 'Original Price',
    discount: 'Discount',
    finalPrice: 'Final Price',
    percentOff: 'off',
    durationOnce: 'one-time discount',
    durationRepeating: 'recurring discount',
    durationRepeatingOneMonth: 'for 1 month',
    durationRepeatingMonths: 'for {months} months',
    durationForever: 'permanent discount',
    paymentInformation: 'Payment Information',
    securePaymentNotice: '🔒 Payments are securely processed by Stripe. Your card information is never stored on our servers.',
    processing: 'Processing...',
    confirmSubscription: 'Confirm Subscription',
    paymentFailed: 'Payment Failed',
    errorDetails: 'Error Details',
    adminSeatMinimumReached: 'Cannot reduce below the number of admins you currently have',
    userSeatMinimumReached: 'Cannot reduce below the number of users you currently have',
    adminSeatLimitReached: 'If you need more admins, please contact us at info@mrwolfapp.com',
    userSeatLimitReached: 'If you need more users, please contact us at info@mrwolfapp.com',
    inUse: 'in use',
    cancellationDate: 'Cancellation Date',
    subscriptionLoadError: 'Unable to Load Subscription Details',
  },
  subscriptions: {
    subscriptions: 'Subscriptions',
    sandboxMode: 'Running in Sandbox Mode',
    noStripeKeyNotice: 'Stripe payment integration is not enabled yet. Subscription functionality is not available.',
    totalMRR: 'Total MRR',
    activeSubscriptions: 'Active Subscriptions',
    trialSubscriptions: 'Trial Subscriptions',
    allSubscriptions: 'All Subscriptions',
    plan: 'Plan',
    status: 'Status',
    active: 'Active',
    trial: 'Trial',
    canceled: 'Canceled',
    pastDue: 'Past Due',
    users: 'Users',
    adminSeats: 'Admin Seats',
    userSeats: 'User Seats',
    totalSeats: 'Total Seats',
    monthlyRevenue: 'Monthly Revenue',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    noSubscriptions: 'No subscriptions found',
    note: 'Note',
    cancelAtPeriodEndTooltip: 'This subscription will cancel at the end of the current billing period',
  },
};

export default en;
